//src\containers\assets\AssetsListContainer.js

import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import FileSaver from 'file-saver';
import moment from 'moment';

import {
  getAssets,
  setPagination,
  setFilters,
  resetAssetsList,
  getAssetsCSV,
  getAssetsXLSX,
} from 'containers/assets/actions';

import {
  getPagination,
  getFilters,
  getIsLoadingList,
  getVisibleAssets,
  getNeedFetch,
} from 'selectors/assets';
import {
  getVisibleAccountsParent,
  getVisibleCostCenters,
  getVisibleProviders,
  getVisibleProjects,
  getVisiblePhysicalState,
  getVisibleEmployees,
  getVisibleLocations,
  getVisibleStatus,
} from 'selectors/lists';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import Assets from 'components/assets';
import AssetsEnableModalContianer from 'containers/assets/AssetsEnableModalContianer';
import AssetsRowContainer from 'containers/assets/AssetsRowContainer';
import AssetsFormConfig from 'containers/assets/AssetsFormConfig';

import { valueFromEvent } from 'lib/util';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import PropTypes from 'prop-types';

class AssetsListContainer extends PureComponent {
  refresh = () => this.fetch(this.props.pagination, this.props.filters);
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  state = {
    exactSearch: false,
    columnSearch: [
      // Cambiar por redux
      {
        key: 'indexInteger.numberString',
        name: this.props.t('assets.fields.historics.searchEditor.consecutive'),
        search: true,
      },
      {
        key: '_prefix.value',
        name: this.props.t('assets.fields.historics.searchEditor.prefix'),
        search: true,
      },
      {
        key: 'number',
        name: this.props.t('assets.fields.historics.searchEditor.number'),
        search: true,
      },
      {
        key: 'name',
        name: this.props.t('assets.fields.historics.searchEditor.name'),
        search: true,
      },
      {
        key: 'serie',
        name: this.props.t('assets.fields.historics.searchEditor.serie'),
        search: true,
      },
      {
        key: 'description',
        name: this.props.t('assets.fields.historics.searchEditor.description'),
        search: true,
      },
      {
        key: '_account.name',
        name: this.props.t('assets.fields.historics.searchEditor.account'),
        search: true,
      },
      {
        key: '_subaccount.name',
        name: this.props.t('assets.fields.historics.searchEditor.subAccount'),
        search: true,
      },
      {
        key: '_costCenter.name',
        name: this.props.t('assets.fields.historics.searchEditor.costCenter'),
        search: true,
      },
      {
        key: '_employee.name',
        name: this.props.t('assets.fields.historics.searchEditor.employee'),
        search: true,
      },
      {
        key: '_provider.name',
        name: this.props.t('assets.fields.historics.searchEditor.provider'),
        search: true,
      },
      {
        key: 'buyOrder',
        name: this.props.t('assets.fields.historics.searchEditor.buyOrder'),
        search: true,
      },
      {
        key: 'billNumber',
        name: this.props.t('assets.fields.historics.searchEditor.billNumber'),
        search: true,
      },
      {
        key: 'billFolio',
        name: this.props.t('assets.fields.historics.searchEditor.billFolio'),
        search: true,
      },
      {
        key: 'billConcept',
        name: this.props.t('assets.fields.historics.searchEditor.billConcept'),
        search: true,
      },
      {
        key: 'customsDocumentsPedimentoNumber',
        name: this.props.t('assets.fields.historics.searchEditor.customs_documents_pedimento_number'),
        search: true,
      },
      {
        key: 'customsDocumentsCustomsKey',
        name: this.props.t('assets.fields.historics.searchEditor.customs_documents_customs_key'),
        search: true,
      },
      {
        key: 'customsDocumentsPedimentoKey',
        name: this.props.t('assets.fields.historics.searchEditor.customs_documents_pedimento_key'),
        search: true,
      },
      {
        key: '_files.name',
        name: this.props.t('assets.fields.historics.searchEditor.file'),
        search: true,
      },
    ],
  };

  handleExactSearch = () => {
    let exactSearch = this.state.exactSearch;
    this.props.setFilters({ exactSearch });
    this.setState({ exactSearch: !exactSearch });
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };

  fetch = (pagination, filters) => {
    const { company, subcompany } = this.props;

    this.props.getAssets(
      company.id,
      subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );
  };

  fetchDebounced = debounce(this.fetch, 200);

  componentWillMount = () => {
    this.props.reset();
    this.fetch(this.props.pagination, this.props.filters);
    this.props.filters.location = ""
  };

  componentWillUnmount = () => {
    this.props.reset();
  };

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.needFetch &&
      (!isEqual(nextProps.pagination, this.props.pagination) ||
        !isEqual(nextProps.filters, this.props.filters))
    ) {
      this.fetchDebounced(nextProps.pagination, nextProps.filters);
    }
  };

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleFiltersSubmit = (e) => {
    e.preventDefault();
    this.fetch(this.props.pagination, this.props.filters);
  };

  handleExport = (e) => {
    const { company, subcompany } = this.props;
    this.props
      .getAssetsCSV(company.id, subcompany.id, this.props.filters)
      .then(({ value }) => {
        const blob = new Blob([value.data], { type: 'text/csv;charset=utf-8' });
        FileSaver.saveAs(blob, `activos-${moment().format('DDMMYYYY')}.csv`);
      })
      .catch((e) => {});
  };

  /**
   * Export assets list to XLSX format file when the user clicks on the export XLSX button
   * @author Jorge Casas
   *
   * @param {object} e - Event object
   * @returns {void}
   */
  handleExportXLSX = (e) => {
    const { company, subcompany } = this.props;
    this.props
      .getAssetsXLSX(company.id, subcompany.id, this.props.filters)
      .then((response) => {
        if (
          response &&
          response.value &&
          response.value.data &&
          response.value.data.type === 'Buffer' &&
          Array.isArray(response.value.data.data) &&
          response.value.data.data.length > 0
        ) {
          const dataArray = new Uint8Array(response.value.data.data);
          const blob = new Blob([dataArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          FileSaver.saveAs(blob, `activos-${moment().format('DDMMYYYY')}.xlsx`);
        } else {
          console.error('The response does not contain valid data:', response);
        }
      })
      .catch((error) => {
        console.error('Error exporting XLSX:', error);
      });
  };

  render = () => {
    const { assets, company, filters, isLoading, pagination, permissions, subcompany } = this.props;
    // assets.filter(asset => asset.createdAt = asset.createdAt.slice(0,10))
    return (
      <AssetsFormConfig
        render={() => (
          <Fragment>
            <Assets.List
              assets={assets}
              accounts={this.props.accounts}
              costCenters={this.props.costCenters}
              employees={this.props.employees}
              locations={this.props.locations}
              providers={this.props.providers}
              projects={this.props.projects}
              physicalState={this.props.physicalState}
              status={this.props.status}
              companyId={company.id}
              filters={filters}
              isLoading={isLoading}
              pagination={pagination}
              permissions={permissions}
              subcompanyId={subcompany.id}
              count={assets.length}
              handleExport={this.handleExport}
              handleExportXLSX={this.handleExportXLSX}
              handleFiltersSubmit={this.handleFiltersSubmit}
              handleFiltersChange={this.handleFiltersChange}
              handleOrderChange={this.handleOrderChange}
              handleLimitChange={this.handleLimitChange}
              handlePageChange={this.handlePageChange}
              handleToggleSearch={this.handleToggleSearch}
              handleExactSearch={this.handleExactSearch}
              columnSearch={this.state.columnSearch}
            >
              {assets.map((asset) => (
                <AssetsRowContainer filters={filters} asset={asset} key={asset.id} />
              ))}
            </Assets.List>
            <AssetsEnableModalContianer fetch={this.refresh} />
          </Fragment>
        )}
      />
    );
  };
}

const mapStateToProps = (state) => ({
  assets: getVisibleAssets(state),
  company: getCompany(state),
  filters: getFilters(state),
  isLoading: getIsLoadingList(state),
  pagination: getPagination(state),
  permissions: getPermissions(state),
  subcompany: getSubcompany(state),
  needFetch: getNeedFetch(state),
  accounts: getVisibleAccountsParent(state),
  costCenters: getVisibleCostCenters(state),
  employees: getVisibleEmployees(state),
  locations: getVisibleLocations(state),
  providers: getVisibleProviders(state),
  projects: getVisibleProjects(state),
  physicalState: getVisiblePhysicalState(state),
  status: getVisibleStatus(state),
});
const mapDispatchToProps = {
  getAssets,
  setPagination,
  setFilters,
  reset: resetAssetsList,
  getAssetsCSV,
  getAssetsXLSX,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(AssetsListContainer);



// WEBPACK FOOTER //
// src/containers/assets/AssetsListContainer.js